import axios from "axios";
import BASE_URL from "../../config";

// Get the auth token from localStorage and return headers
const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

// Get banks with filters and pagination
export const getBanks = async (filter = {}) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/Bank/get`,
      filter,
      { headers: getAuthHeader() }
    );
    return response.data;
  } catch (error) {
    console.error("Error getting banks:", error);
    throw error;
  }
};

// Save bank
export const saveBank = async (bankData) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/Bank/save`,
      bankData,
      { headers: getAuthHeader() }
    );
    return response.data;
  } catch (error) {
    console.error("Error saving bank:", error);
    throw error;
  }
};

// Generate bank code
export const generateBankCode = async () => {
  try {
    const response = await axios.get(
      `${BASE_URL}/api/Bank/generate-bank-code`,
      { headers: getAuthHeader() }
    );
    return response.data;
  } catch (error) {
    console.error("Error generating bank code:", error);
    throw error;
  }
};

